import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultOrdersTicketData = {
  id: 0,
  enabled: true,
  userId: 0,
  orderId: null,
  status: 'Open',
  closureComments: '',
  comments: '',
  attachment1: '',
  attachment2: '',
  attachment3: '',
  user: {
    id: null
  },
  order: {
    id: null
  }
};
export const getOrdersTickets = params => request({
  url: '/orders-tickets',
  method: 'get',
  params
});
export const getOrdersTicketById = id => request({
  url: `/orders-tickets/${id}`,
  method: 'get'
});
export const updateOrdersTicket = (id, data) => request({
  url: `/orders-tickets/${id}`,
  method: 'patch',
  data
});
export const deleteOrdersTicket = id => request({
  url: `/orders-tickets/${id}`,
  method: 'delete'
});
export const createOrdersTicket = data => request({
  url: '/orders-tickets/',
  method: 'post',
  data
});
export const ordersTicketsCount = params => request({
  url: '/orders-tickets/count',
  method: 'get',
  params
});